import React, { useMemo, ReactNode } from "react";
import GaraazInput from "./GaraazInput";
import { isValidAmount, preventScientificNotationInput } from "../utils/amountValidation";

export interface GaraazAmountInputProps {
  width: any;
  label?: string;
  inputName: string;
  placeholder?: string;
  value: string;
  onValueChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => void;
  onValidityChange?: (valid: boolean) => void;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  inputLeftAddOn?: ReactNode;
  inputRightAddOn?: ReactNode;
  border?: string;
}

const GaraazAmountInput: React.FC<GaraazAmountInputProps> = ({
  width,
  label = "Amount",
  inputName,
  placeholder = "Enter amount",
  value,
  onValueChange,
  onValidityChange,
  isReadOnly,
  isDisabled,
  inputLeftAddOn,
  inputRightAddOn,
  border,
}) => {
  const isCurrentValid = useMemo(() => isValidAmount(value), [value]);

  React.useEffect(() => {
    onValidityChange?.(isCurrentValid);
  }, [isCurrentValid, onValidityChange]);

  return (
    <GaraazInput
      width={width}
      label={label}
      inputName={inputName}
      inputType="number"
      placeholder={placeholder}
      value={value}
      isRequired={false}
      onChange={onValueChange}
      isReadOnly={isReadOnly}
      isDisabled={isDisabled}
      inputLeftAddOn={inputLeftAddOn}
      inputRightAddOn={inputRightAddOn}
      errorMsg={
        !isCurrentValid && value !== "" ? "Enter a valid amount" : undefined
      }
      onKeyDown={preventScientificNotationInput}
      border={border}
    />
  );
};

GaraazAmountInput.displayName = "GaraazAmountInput";

export default GaraazAmountInput;
